(function (window, document) {
  'use strict';

  /** 使用数组方法遍历集合，兼容不支持 NodeList.forEach 的浏览器。 */
  var forEach = function (list, callback) {
    Array.prototype.forEach.call(list || [], callback);
  };

  /** 判断候选表单是否真正显示，避免取到页面中已隐藏的重复区块。 */
  function isVisible(element) {
    return Boolean(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
  }

  /** 优先使用当前商品区块的附加属性表单，找不到时再回退到页面中的可见表单。 */
  function findAppendForm(productForm) {
    var scope = productForm && productForm.closest ? productForm.closest('product-info') : null;
    // The explicit send-later path uses ordinary customer details and never
    // borrows an old ready AI form from a different personalization session.
    var emergency = window.GIOMultiSurfaceEmergency;
    if (scope && emergency && emergency.isPrepared(scope)) return emergency.getAppendForm(scope) || scope.querySelector('form#appendForm');
    // The six-face cube stores its properties in its own product data form.
    // Never borrow a photo/AI modal left behind by another product instance.
    if ((productForm && productForm.dataset.cube6Required === 'true') ||
        (scope && scope.querySelector('[data-gio-cube6]'))) return null;
    // 只有服务端已完成最终低清图时才采用 AI 独立表单。booting、
    // active、失败和 fallback 状态继续走原来的 appendForm。
    var aiForm = scope
      ? scope.querySelector('form[data-gio-ai-form][data-ai-mode="ai"][data-ai-state="ready"]')
      : null;
    if (aiForm) return aiForm;

    var scoped = scope ? scope.querySelector('form#appendForm') : null;
    if (scoped) return scoped;

    var forms = document.querySelectorAll('form#appendForm');
    for (var index = 0; index < forms.length; index += 1) {
      if (isVisible(forms[index])) return forms[index];
    }
    return forms.length ? forms[0] : null;
  }

  /**
   * 清理上传界面中的区域名称，使其可安全用作 Shopify line item property 名称。
   * 撇号、&、正斜杠和 Unicode 等可见字符会保留；仅处理控制字符、结构字符和异常空白。
   */
  function normalizeLabel(label, fallbackIndex) {
    var numericIndex = Number(fallbackIndex);
    var fallback = 'Preview' + (isFinite(numericIndex) ? numericIndex + 1 : 1);
    var value = label === undefined || label === null ? '' : String(label);
    if (typeof value.normalize === 'function') value = value.normalize('NFC');
    value = value
      .replace(/[\u0000-\u001F\u007F-\u009F]/g, ' ')
      .replace(/[\u200B-\u200F\u202A-\u202E\u2066-\u2069\uFEFF]/g, '')
      .replace(/"/g, '”')
      .replace(/\\/g, '/')
      .replace(/\[/g, '(')
      .replace(/\]/g, ')')
      .replace(/\s+/g, ' ')
      .trim();
    // Shopify 将下划线开头的属性视为私有属性；这里加上可见前缀，避免名称在购物车中被隐藏。
    if (value.charAt(0) === '_') value = 'Photo ' + value.replace(/^_+/, '');

    // 避免与生产流程仍在使用的技术属性名冲突。
    if (/^(?:Preview|Original(?:Photo)?|HD)\d*$/i.test(value)) value = 'Photo ' + value;
    return value || fallback;
  }

  /** 为每张预览图生成唯一属性名；标签重复时追加序号，防止后一个链接覆盖前一个链接。 */
  function uniqueLabel(base, used) {
    var candidate = base;
    var number = 2;
    while (Object.prototype.hasOwnProperty.call(used, candidate)) {
      candidate = base + ' (' + number + ')';
      number += 1;
    }
    used[candidate] = true;
    return candidate;
  }

  /** 按当前上传界面的排列顺序读取客户实际看到的区域名称，避免标签切换后使用过期名称。 */
  function uploadLabels(appendForm) {
    if (!appendForm) return [];
    return Array.prototype.map.call(
      appendForm.querySelectorAll('.upload-container > label'),
      function (label) { return label.textContent || ''; }
    );
  }

  /**
   * 读取表单值：有 jQuery 时沿用 serializeArray，没有时使用原生 DOM 兼容实现。
   * 文件输入由定制上传流程处理，因此这里有意跳过 file 类型。
   */
  function formValues(form) {
    if (!form) return [];
    if (window.jQuery && typeof window.jQuery(form).serializeArray === 'function') {
      return window.jQuery(form).serializeArray();
    }

    var result = [];
    var elements = form.elements || [];
    for (var index = 0; index < elements.length; index += 1) {
      var element = elements[index];
      if (!element.name || element.disabled || /^(?:submit|button|file|reset)$/i.test(element.type)) continue;
      if (/^(?:checkbox|radio)$/i.test(element.type) && !element.checked) continue;
      if (element.options && element.multiple) {
        for (var optionIndex = 0; optionIndex < element.options.length; optionIndex += 1) {
          if (element.options[optionIndex].selected) {
            result.push({ name: element.name, value: element.options[optionIndex].value });
          }
        }
      } else {
        result.push({ name: element.name, value: element.value });
      }
    }
    return result;
  }

  /** 校验并解析上传控件写入的图片映射；数据损坏时停止加购，避免生成残缺订单。 */
  function parseImageMap(value, typeName) {
    var text = String(value || '').trim();
    if (text.charAt(0) !== '{') return null;
    var parsed;
    try {
      parsed = JSON.parse(text);
    } catch (error) {
      throw new Error(typeName + ' upload data is invalid. Please upload the photo again.');
    }
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      throw new Error(typeName + ' upload data is invalid. Please upload the photo again.');
    }
    return parsed;
  }

  /**
   * Keep the legacy Original aliases used by order/ERP and named cart previews,
   * but submit each design source URL only once. The editor's complete hidden
   * fields and manifest photo-slot mapping stay intact for validation/recovery.
   */
  function deduplicateDesignSources(properties) {
    var names = Object.keys(properties);
    names.forEach(function (name) {
      var manifestMatch = /^properties\[_DesignManifest(\d+)\]$/.exec(name);
      if (!manifestMatch) return;
      var manifest;
      try { manifest = new URL(properties[name]); } catch (error) { return; }
      if (!/^https?:$/.test(manifest.protocol) || manifest.username || manifest.password || manifest.hash ||
          !/\/gio-[A-Za-z0-9_-]+-design\.json$/.test(manifest.pathname)) return;
      var photoPrefix = manifest.pathname.replace(/-design\.json$/, '-photo-');
      var seen = Object.create(null);
      function isJobPhoto(value) {
        if (typeof value !== 'string') return false;
        var source;
        try { source = new URL(value); } catch (error) { return false; }
        return source.origin === manifest.origin && !source.username && !source.password && !source.hash &&
          source.pathname.indexOf(photoPrefix) === 0 &&
          /^(?:0|[1-9]\d*)\.[A-Za-z0-9]+$/.test(source.pathname.slice(photoPrefix.length));
      }
      names.forEach(function (aliasName) {
        if (/^properties\[_?Original(?:Photo)?(?:\d+| - .+)?\]$/.test(aliasName) &&
            isJobPhoto(properties[aliasName])) seen[properties[aliasName]] = true;
      });
      names.forEach(function (sourceName) {
        var sourceMatch = /^properties\[_DesignSource(\d+)_(\d+)\]$/.exec(sourceName);
        if (!sourceMatch || sourceMatch[1] !== manifestMatch[1]) return;
        var value = properties[sourceName];
        if (!isJobPhoto(value)) return;
        if (seen[value]) delete properties[sourceName];
        else seen[value] = true;
      });
    });
    return properties;
  }

  /** Keep the validated native form intact; only the outgoing cart copy is
   * compacted. An incomplete manifest upload keeps every recovery field. */
  function compactLayeredProperties(properties) {
    var job = properties['properties[_LayeredJobId]'];
    if (properties['properties[_DesignSchema]'] !== 'gio-layered-design-v1' ||
        typeof job !== 'string' || !/^gio-layered-[a-z0-9]{1,24}-[a-f0-9]{32}$/.test(job)) return properties;
    var manifestValue = properties['properties[_DesignManifest0]'], manifest;
    try { manifest = new URL(manifestValue); } catch (_) { return properties; }
    if (manifest.protocol !== 'https:' || manifest.username || manifest.password || manifest.port || manifest.hash || manifest.search ||
        !(manifest.hostname === 'static.giftinone.com' || /^giftinone\.s3(?:[.-][a-z0-9-]+)?\.amazonaws\.com$/.test(manifest.hostname)) ||
        manifest.pathname !== '/orders/' + job + '-design.json') return properties;
    // Layered personalization owns a single print area. Never compact a mixed
    // legacy/multi-area submission because another area's sources may be needed.
    if (Object.keys(properties).some(function (name) {
      return /^properties\[_DesignManifest\d+\]$/.test(name) && name !== 'properties[_DesignManifest0]';
    })) return properties;
    Object.keys(properties).forEach(function (name) {
      var match = /^properties\[(.*)\]$/.exec(name);
      if (!match) return;
      var field = match[1], value = properties[name];
      var duplicate = /^(?:_DesignSchema|_LayeredJobId|_LayeredSnapshot\d*|_Layered(?:Selections|Intent|MissingAssets)\d*|_DesignSource\d+_\d+|_CustomerTextMeta\d+_\d+_\d+)$/.test(field);
      var emptyOptional = /^(?:_?Original(?:Photo)?(?:\d+| - .+)?|_VIPService|_ProductionReason)$/.test(field) &&
        (value == null || typeof value === 'string' && !value.trim());
      if (duplicate || emptyOptional || field === '_ProductionMode' && value === 'auto') delete properties[name];
    });
    return properties;
  }

  /**
   * 将 Preview、OriginalPhoto 和 _HD 图片映射展开为 Shopify 行项目属性。
   * 同一上传位的三种图片沿用同一个可见名称，并保留已有的文字等定制属性。
   * HD 使用私有属性名，在 Shopify Checkout 隐藏，订单后台仍保留生产链接。
   * Design 的原片同样设为私有：拼图的客户可见图是完整 Preview，不能只显示第一张原片。
   */
  function buildProperties(values, appendForm) {
    var result = {};
    var used = Object.create(null);
    var resolved = Object.create(null);
    var labels = uploadLabels(appendForm);
    var creativeSlots = Object.create(null);
    values.forEach(function (item) {
      var manifest = /^properties\[_DesignManifest(\d+)\]$/.exec(item.name);
      if (manifest && String(item.value || '').trim()) creativeSlots[String(Number(manifest[1]))] = true;
    });
    var hasCreativeDesign = Object.keys(creativeSlots).length > 0;

    // Preserve legacy first-source aliases. Duplicate DesignSource properties
    // are removed only from the final submission, after all fields are mapped.
    function privateOriginalName(name) {
      if (!hasCreativeDesign) return name;
      if (name === 'Original' || name === 'OriginalPhoto') return '_' + name;
      var numbered = /^Original(?:Photo)?(\d+)$/.exec(name);
      if (numbered && creativeSlots[String(Number(numbered[1]) - 1)]) return '_' + name;
      var named = /^Original(?:Photo)? - (.+)$/.exec(name);
      if (named && Object.keys(creativeSlots).some(function (index) {
        return named[1] === normalizeLabel(labels[Number(index)], Number(index));
      })) return '_' + name;
      return name;
    }

    // 预留页面上已有的自定义属性名，避免图片标签覆盖文字或其他定制信息。
    // 将上传的图片加入到properties里面：处理图片数组，并保留普通文字和其他 properties 字段。
    values.forEach(function (item) {
      var match = /^properties\[(.*)\]$/.exec(item.name);
      var imageArray = item.name === 'properties[Preview]' ||
        item.name === 'properties[OriginalPhoto]' ||
        item.name === 'properties[_HD]' || item.name === 'properties[HD]';
      if (match && !imageArray) {
        var reservedName = /^HD(?:\d+| - .+)?$/i.test(match[1]) ? '_' + match[1] : privateOriginalName(match[1]);
        used[reservedName] = true;
      }
    });

    /** 为同一上传槽位缓存最终可读名称，保证 Preview、Original 和 HD 始终引用同一个位置名称。 */
    function slotLabel(index) {
      var key = String(index);
      if (!Object.prototype.hasOwnProperty.call(resolved, key)) {
        resolved[key] = uniqueLabel(normalizeLabel(labels[index], index), used);
      }
      return resolved[key];
    }

    values.forEach(function (item) {
      var type = '';
      if (item.name === 'properties[Preview]') type = 'Preview';
      if (item.name === 'properties[OriginalPhoto]') type = 'Original';
      // 兼容仍在页面上的旧上传控件；所有出口统一为 Shopify 私有属性。
      if (item.name === 'properties[_HD]' || item.name === 'properties[HD]') type = 'HD';

      var imageMap = type ? parseImageMap(item.value, type) : null;
      if (!imageMap) {
        var propertyMatch = /^properties\[(HD(?:\d+| - .+)?)\]$/i.exec(item.name);
        var originalMatch = /^properties\[(Original(?:Photo)?(?:\d+| - .+)?)\]$/.exec(item.name);
        var fieldName = propertyMatch ? 'properties[_' + propertyMatch[1] + ']'
          : originalMatch ? 'properties[' + privateOriginalName(originalMatch[1]) + ']' : item.name;
        result[fieldName] = item.value;
        return;
      }

      Object.keys(imageMap).forEach(function (key, position) {
        var parsedIndex = parseInt(key, 10);
        var index = isNaN(parsedIndex) ? position : parsedIndex;
        var propertyName;
        var typePrefix = type === 'HD' ? '_HD' : type === 'Original' && creativeSlots[String(index)] ? '_Original' : type;
        if (type === 'Preview') {
          propertyName = slotLabel(index);
        } else if (labels[index] !== undefined) {
          propertyName = uniqueLabel(typePrefix + ' - ' + slotLabel(index), used);
        } else {
          propertyName = uniqueLabel(typePrefix + (index + 1), used);
        }
        result['properties[' + propertyName + ']'] = imageMap[key];
      });
    });
    // A manual-production design intentionally has no HD URL. Omit only empty
    // HD-family properties; preserve other empty personalization/metadata fields
    // and every non-empty HD link used by crop, AI and template orders.
    Object.keys(result).forEach(function (name) {
      var value = result[name];
      if (/^properties\[_?HD(?:\d+| - .+)?\]$/i.test(name) &&
          (value == null || typeof value === 'string' && !value.trim())) {
        delete result[name];
      }
    });
    return compactLayeredProperties(deduplicateDesignSources(result));
  }

  /** 快速购买等上下文可能未加载主题发布模块，仅在可用时发送购物车事件。 */
  function safePublish(eventName, payload) {
    try { if (typeof publish === 'function' && eventName) publish(eventName, payload); }
    catch (error) { console.warn('Cart saved; a cart update listener failed.', error); }
  }

  function normalizedProperties(properties) {
    var result = {};
    Object.keys(properties || {}).sort().forEach(function (key) {
      var value = properties[key];
      if (value !== null && value !== undefined && String(value) !== '') result[key] = String(value);
    });
    return result;
  }

  function cartIdentity(item) {
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    return JSON.stringify([String(item.variant_id || item.id || ''), String(item.selling_plan || plan && plan.id || ''), normalizedProperties(item.properties)]);
  }

  function matchingQuantity(cart, identity) {
    return (cart.items || []).reduce(function (total, item) {
      return total + (cartIdentity(item) === identity ? Number(item.quantity || 0) : 0);
    }, 0);
  }
  var pendingCartSubmissions = Object.create(null);

  /**
   * 只向本次实际参与加购的 AI form 发送结果，避免主商品区块、Quick Add
   * 或相同 variant 的其他实例误收全局购物车事件。
   */
  function notifyAi(form, eventName, detail) {
    if (!form || !form.matches || !form.matches('form[data-gio-ai-form]')) return;
    var event;
    if (typeof window.CustomEvent === 'function') {
      event = new window.CustomEvent(eventName, { detail: detail || {} });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(eventName, false, false, detail || {});
    }
    form.dispatchEvent(event);
  }

  if (!window.customElements || window.customElements.get('product-form')) return;

  /**
   * 商品加入购物车的操作：管理定制校验、变体状态、加入购物车请求及购物车界面刷新。
   * 所有 DOM 查询尽量限制在当前 product-info，避免主商品与快速购买弹窗互相串值。
   */
  class ProductForm extends HTMLElement {
    /**
     * 初始化当前 product-form：读取表单和按钮、绑定提交事件，并同步初始库存状态。
     * 如果主题区块缺少表单或提交按钮，只保留组件实例，不继续绑定加购逻辑。
     */
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.isSubmitting = false;
      this.error = false;
      this.variantDisabled = this.submitButton ? Boolean(this.submitButton.disabled) : true;
      this.variantText = this.submitButtonText ? this.submitButtonText.textContent : '';

      if (!this.form || !this.submitButton) return;
      if (this.variantIdInput) this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.syncCustomizeButtonState(this.variantDisabled, this.variantText);
    }

    /** 限定在当前商品区块内查询，避免主页面和快速购买弹窗相互串值。 */
    get scope() {
      return this.closest('product-info') || this;
    }

    /** 返回当前商品表单内的 Shopify 变体 ID 输入框；表单不存在时返回 null。 */
    get variantIdInput() {
      return this.form ? this.form.querySelector('[name="id"]') : null;
    }

    /** 优先读取定制弹窗中的数量，找不到时回退到当前商品表单。 */
    quantity(appendForm) {
      if (appendForm && appendForm.matches &&
          appendForm.matches('form[data-gio-ai-form][data-ai-mode="ai"]')) {
        // A hidden legacy customizer can retain the previous order's quantity.
        // AI uses only its own field or this product's visible quantity control.
        var aiInput = appendForm.querySelector('[name="quantity"]') ||
          this.scope.querySelector('.quantity__input[name="quantity"]') ||
          (this.form ? this.form.querySelector('[name="quantity"]') : null);
        return aiInput ? String(aiInput.value || '').trim() : '1';
      }
      var input = appendForm ? appendForm.querySelector('#quantityNumber, [name="quantity"]') : null;
      input = input || this.scope.querySelector('#quantityNumber, .quantity__input[name="quantity"]');
      input = input || (this.form ? this.form.querySelector('[name="quantity"]') : null);
      return input ? String(input.value || '').trim() : '1';
    }

    /** 兼容主页面和弹窗两种 VIP 状态节点位置。 */
    vipEnabled() {
      if (this.dataset.cube6Required === 'true' || this.scope.querySelector('[data-gio-cube6]')) return false;
      var node = this.scope.querySelector('#vipstatus') || document.getElementById('vipstatus');
      return Boolean(node && String(node.textContent || '').trim() === '1');
    }

    /** 同时更新主题标准错误区和旧定制组件仍在使用的错误区。 */
    showError(message) {
      this.handleErrorMessage(message);
      var legacy = this.scope.querySelector('.product-form__error-message-wrapper--hidden');
      if (legacy) {
        legacy.style.display = message ? 'flex' : 'none';
        var output = legacy.querySelector('.product-form__error-message');
        if (output && message) output.textContent = message;
      }
    }

    /**
     * 在请求购物车前统一校验定制内容。
     * 图片必须覆盖所有上传位，文字输入框不得为空，魔方商品必须完成定制，数量必须为不小于 1 的有限数字。
     */
    validate(appendForm, quantity, aiReady) {
      // Legacy modal SKU synchronization may update the hidden variant and
      // re-enable buttons before Shopify returns the selected editor route.
      // The form itself remains the final gate until that response is applied.
      if (this.scope.dataset.gioEditorRoute &&
          (this.scope.pendingRequestUrl || this.scope.dataset.gioEditorRouteChanging === 'true')) {
        return 'Your product options are updating. Please wait and try again.';
      }
      var emergency = window.GIOMultiSurfaceEmergency;
      var manualCheck = emergency && emergency.validateForCart(this.variantIdInput && this.variantIdInput.value, this.scope);
      if (manualCheck) {
        if (!manualCheck.valid) return manualCheck.message || 'Confirm manual personalization before ordering.';
        if (!Number.isFinite(Number(quantity)) || !Number.isInteger(Number(quantity)) || Number(quantity) < 1) return 'Quantity must be a whole number of 1 or more';
        return '';
      }
      var nativeCube = this.scope.querySelector('[data-gio-cube6]');
      if (nativeCube || this.dataset.cube6Required === 'true') {
        var cubeReady = nativeCube && nativeCube.querySelector('#is-cube-upload');
        var cubeImages = nativeCube && nativeCube.querySelector('[name="properties[multi_images]"]');
        if (!nativeCube || nativeCube.dataset.cubeState !== 'ready' || !cubeReady || cubeReady.value !== '1') {
          return nativeCube && nativeCube.dataset.cubeState === 'uploading'
            ? 'Please wait for all six cube photos to finish uploading.'
            : 'Please customize and save all six cube faces before adding to cart.';
        }
        try {
          var faces = JSON.parse(cubeImages ? cubeImages.value : '');
          if (!faces || typeof faces !== 'object' || Array.isArray(faces) || Object.keys(faces).length !== 6) throw new Error('Invalid cube faces');
          for (var faceIndex = 0; faceIndex < 6; faceIndex += 1) {
            var face = faces[String(faceIndex)];
            if (!face || typeof face.src !== 'string') throw new Error('Missing cube face');
            var faceUrl = new URL(face.src);
            if (faceUrl.protocol !== 'https:' || faceUrl.hostname !== 'static.giftinone.com' ||
                faceUrl.username || faceUrl.password || faceUrl.port ||
                !/^\/orders\/[^/]+\.(?:png|jpe?g|webp)$/i.test(faceUrl.pathname)) throw new Error('Invalid cube photo URL');
          }
        } catch (error) {
          return 'Your cube photos are incomplete. Please save all six faces again.';
        }
        if (!isFinite(Number(quantity)) || Number(quantity) < 1) return 'Quantity must be 1 or more';
        return '';
      }
      var chosenAi = this.scope.querySelector('form[data-gio-ai-form][data-ai-mode="ai"]');
      if (chosenAi && !aiReady) return 'Please finish your AI design before adding to cart';
      if (aiReady) {
        if (appendForm.dataset.aiCartState === 'unknown') {
          return 'Open or refresh your cart to confirm the previous item before trying again';
        }
        var previewInput = appendForm.querySelector('[data-ai-preview-property]');
        var hdInput = appendForm.querySelector('[data-ai-hd-property]');
        var cidInput = appendForm.querySelector('[data-ai-cid-property]');
        var originalInput = appendForm.querySelector('[data-ai-original-property]');
        var overlayInput = appendForm.querySelector('[data-ai-preview-overlay-property]');
        var resetReceiptInput = appendForm.querySelector('[data-ai-reset-receipt]');
        var preview = previewInput ? String(previewInput.value || '').trim() : '';
        var cid = cidInput ? String(cidInput.value || '').trim() : '';
        var original = originalInput ? String(originalInput.value || '').trim() : '';
        var previewOverlay = overlayInput ? String(overlayInput.value || '').trim() : '';
        var aiState = appendForm._giftInOneAiState;
        var selectedDesign = aiState && Array.isArray(aiState.designs)
          ? aiState.designs.find(function (design) { return design.cid === cid; })
          : null;
        var versionInput = appendForm.querySelector('[data-ai-design-version-property]');
        var schemaInput = appendForm.querySelector('[data-ai-preview-schema-property]');
        var version = versionInput ? String(versionInput.value || '') : '';
        var previewOverlayValid = !previewOverlay && (!overlayInput || overlayInput.disabled);
        var resetReceipt = resetReceiptInput
          ? String(resetReceiptInput.value || '')
          : '';
        var expectedPreview =
          'https://static.giftinone.com/aiOrders/' + cid + '/preview/final-' + version + '.png';
        var expectedHd =
          'https://static.giftinone.com/aiOrders/' + cid + '/production/final.png';
        var resetReceiptValid =
          /^gor1\.[A-Za-z0-9_-]{80,205}\.[A-Za-z0-9_-]{43}$/.test(resetReceipt);
        if (
          appendForm.dataset.aiState !== 'ready' || appendForm.dataset.aiMode !== 'ai' ||
          !versionInput || versionInput.disabled || !/^[a-f0-9]{64}$/.test(version) ||
          !schemaInput || schemaInput.disabled || schemaInput.value !== 'gio-complete-preview/v1' ||
          !previewInput || previewInput.disabled ||
          !hdInput || hdInput.disabled || hdInput.value !== expectedHd ||
          !cidInput || cidInput.disabled ||
          !originalInput || !originalInput.disabled || original !== '' ||
          !aiState || aiState.variantNeedsReadjustment || !previewOverlayValid ||
          !selectedDesign || selectedDesign.designVersion !== version ||
          selectedDesign.previewComplete !== true || selectedDesign.previewImageLoaded !== true ||
          selectedDesign.previewFinalUrl !== preview || !aiState.currentVariantContract ||
          String(selectedDesign.boundVariantId || '') !== String(aiState.currentVariantContract.variantId || '') ||
          !this.variantIdInput ||
          String(selectedDesign.boundVariantId || '') !== String(this.variantIdInput.value || '') ||
          !resetReceiptInput || resetReceiptInput.disabled || !resetReceiptValid ||
          !/^\d{14}-[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(cid) ||
          preview !== expectedPreview
        ) {
          return 'Please finish your AI preview before adding to cart';
        }
        if (!isFinite(Number(quantity)) || Number(quantity) < 1) {
          return 'Quantity must be 1 or more';
        }
        return '';
      }

      // A configured vector template has one composition and its own required
      // fields. Validate its committed variant-bound proof, never count legacy
      // per-photo upload widgets as separate production surfaces.
      var templateConfig = window.GIOEditorV2Config;
      var isTemplateProduct = templateConfig && (templateConfig.templateEnabled == null ? templateConfig.templateProfileKey : templateConfig.templateEnabled) && (
        this.scope.id === 'MainProduct-' + String(templateConfig.sectionId || '') ||
        String(this.scope.getAttribute('data-product-id') || '') === String(templateConfig.productId));
      if (isTemplateProduct) {
        var templateBridge = window.GIOEditorV2TemplateAdapter;
        var templateValidation = templateBridge && templateBridge.validateForCart(this.variantIdInput && this.variantIdInput.value);
        if (!templateValidation || !templateValidation.valid) return templateValidation && templateValidation.message || 'The template tools could not load. Please refresh this page.';
        if (!isFinite(Number(quantity)) || Number(quantity) < 1) return 'Quantity must be 1 or more';
        return '';
      }

      var uploadArea = this.scope.querySelector('.upload-images');
      var typeNode = this.scope.querySelector('#liquidData') || document.getElementById('liquidData');
      var type = typeNode ? String(typeNode.textContent || '').trim() : '';

      // 图片校验：图层商品按 avatar-inputs 计数，普通裁剪商品按文件输入框计数。
      if (uploadArea) {
        var expected = type === 'layer'
          ? uploadArea.querySelectorAll('.avatar-inputs').length
          : uploadArea.querySelectorAll('input[type="file"]').length;
        if (expected && this.scope.querySelectorAll('.left img').length < expected) {
          if (typeof window.cartValidate === 'function') window.cartValidate('cropblanket');
          return 'Please upload all photos';
        }
      }

      // 有文本框 验证：任一必填文字为空时标红并停止加购；通过后恢复默认边框。
      var textInputs = this.scope.querySelectorAll('.text-item-wrap input[type="text"]');
      for (var index = 0; index < textInputs.length; index += 1) {
        if (!String(textInputs[index].value || '').trim()) {
          textInputs[index].style.border = '1px solid #f00000';
          return 'Please fill all text';
        }
        textInputs[index].style.border = '1px solid #ccc';
      }

      // 魔方定制组件出现时，隐藏字段必须写入完成标记，不能提交空白魔方。
      if (this.scope.querySelector('.sunzi-modal-mask')) {
        var cube = this.scope.querySelector('#is-cube-upload') || document.getElementById('is-cube-upload');
        if (!cube || !cube.value) return "Please customize your rubik's cube";
      }
      // 数量必须能转换为有限数字且至少为 1，避免向 Shopify 提交 0、负数或 NaN。
      if (!isFinite(Number(quantity)) || Number(quantity) < 1) return 'Quantity must be 1 or more';
      return '';
    }

    /** 用同一状态控制提交锁、按钮和加载动画，避免快速点击造成重复加购。 */
    setSubmitting(active) {
      this.isSubmitting = Boolean(active);
      if (!this.submitButton) return;
      var disabled = this.isSubmitting || this.variantDisabled;
      this.submitButton.disabled = disabled;
      this.submitButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      this.submitButton.classList.toggle('loading', this.isSubmitting);
      var spinner = this.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !this.isSubmitting);
      this.syncCustomizeButtonState(this.variantDisabled, this.variantText);
    }

    /** 不手动设置 Content-Type，让浏览器为 FormData 生成正确的 multipart 边界。 */
    requestConfig(formData) {
      var config = typeof window.fetchConfig === 'function'
        ? window.fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
      config.credentials = 'same-origin';
      config.headers = config.headers || {};
      if (typeof window.Headers !== 'undefined' && config.headers instanceof window.Headers) {
        config.headers.set('X-Requested-With', 'XMLHttpRequest');
        config.headers.delete('Content-Type');
      } else {
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        delete config.headers['content-type'];
      }
      config.body = formData;
      return config;
    }

    /** 同时识别 HTTP 错误和 Shopify JSON 业务错误，交由同一失败流程处理。 */
    parseResponse(response) {
      return response.text().then(function (text) {
        var data;
        try {
          data = text ? JSON.parse(text) : {};
        } catch (error) {
          var invalidResponse = new Error(
            'The cart returned an invalid response. Please check your cart before retrying.'
          );
          invalidResponse.ambiguous = true;
          throw invalidResponse;
        }
        if (!response.ok || (data && data.status)) {
          var message = data && (data.description || data.message || data.errors)
            ? (data.description || data.message || data.errors)
            : 'Could not add this item to cart.';
          var cartError = new Error(String(message));
          cartError.data = data || {};
          cartError.ambiguous = response.status >= 500;
          throw cartError;
        }
        return data || {};
      });
    }

    // A timeout is an unknown write, never permission to repeat a POST.
    requestJson(url, config, timeout) {
      var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
      var timer;
      var request = Object.assign({}, config);
      if (controller) request.signal = controller.signal;
      return Promise.race([
        window.fetch(url, request).then((response) => this.parseResponse(response)),
        new Promise(function (_, reject) {
          timer = window.setTimeout(function () {
            var error = new Error('The cart response took too long. Check your cart before trying again.');
            error.ambiguous = true;
            reject(error);
            if (controller) controller.abort();
          }, timeout);
        })
      ]).finally(function () { window.clearTimeout(timer); });
    }

    readCart(timeout) {
      var url = window.routes && window.routes.cart_url ? String(window.routes.cart_url).replace(/\/+$/, '') + '.js' : '/cart.js';
      return this.requestJson(url, { method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }, timeout || 6000)
        .then(function (cart) { if (!cart || !Array.isArray(cart.items)) throw new Error('Invalid cart state.'); return cart; });
    }

    ordinarySubmission(formData) {
      var properties = {};
      formData.forEach(function (value, name) {
        var match = /^properties\[(.*)\]$/.exec(name);
        if (match) properties[match[1]] = value;
      });
      var item = { id: formData.get('id'), selling_plan: formData.get('selling_plan'), properties: properties };
      return { identity: cartIdentity(item), quantity: Number(formData.get('quantity')), before: null, item: item };
    }

    reconcileOrdinaryCart(submission) {
      return this.readCart().then(function (cart) {
        var found = submission.before !== null && matchingQuantity(cart, submission.identity) >= submission.before + submission.quantity;
        var item = found && cart.items.find(function (line) { return cartIdentity(line) === submission.identity; });
        return { state: found ? 'FOUND' : 'UNKNOWN', cart: cart, item: item || null };
      }).catch(function () { return { state: 'UNKNOWN' }; });
    }

    showCartStatus(message) {
      var host = document.getElementById('GIOCartFeedback') || this.cart && this.cart.querySelector('.cart-notification__links, .drawer__inner');
      if (!host) return;
      var status = host.querySelector('[data-gio-cart-status]');
      if (!status) { status = document.createElement('p'); status.dataset.gioCartStatus = ''; status.setAttribute('role', 'status'); host.prepend(status); }
      status.textContent = message || '';
      status.hidden = !message;
    }

    fallbackCartFeedback(message) {
      var previous = document.getElementById('GIOCartFeedback');
      if (previous) { if (previous.gioDismiss) previous.gioDismiss(false); else previous.remove(); }
      var returnFocus = document.activeElement;
      // Retire the previous cart's focus trap before the emergency confirmation.
      try { if (this.cart && typeof this.cart.close === 'function') this.cart.close({ restoreFocus: false }); }
      catch (_) { /* A damaged cart component is the reason for this fallback. */ }
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
      var panel = document.createElement('section');
      panel.id = 'GIOCartFeedback'; panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true'); panel.setAttribute('aria-label', 'Cart update'); panel.tabIndex = -1;
      panel.style.cssText = 'position:fixed;z-index:2147483000;top:max(16px,env(safe-area-inset-top));right:16px;left:16px;max-width:420px;margin:auto;padding:24px;background:#fff;color:#173d32;box-shadow:0 6px 36px #0004;border:1px solid #d7e4df;border-radius:12px;font:16px/1.5 sans-serif';
      var title = document.createElement('strong'); title.textContent = message || 'Added to cart'; panel.appendChild(title);
      var link = document.createElement('a'); link.href = window.routes && window.routes.cart_url || '/cart'; link.textContent = 'View cart'; link.style.cssText = 'display:block;margin:18px 0;color:#17614d;text-decoration:underline'; panel.appendChild(link);
      panel.gioDismiss = function (restoreFocus) {
        if (typeof removeTrapFocus === 'function') removeTrapFocus(restoreFocus !== false && returnFocus && returnFocus.isConnected ? returnFocus : null);
        panel.remove();
      };
      var close = document.createElement('button'); close.type = 'button'; close.textContent = 'Continue shopping'; close.addEventListener('click', function () { panel.gioDismiss(true); }); panel.appendChild(close);
      panel.addEventListener('keydown', function (event) { if (event.key === 'Escape') { event.preventDefault(); panel.gioDismiss(true); } });
      document.body.appendChild(panel); panel.focus();
      if (typeof trapFocus === 'function') trapFocus(panel);
    }

    showCartSuccess(response, formData, aiSourceForm) {
      var oldFeedback = document.getElementById('GIOCartFeedback');
      if (oldFeedback) { if (oldFeedback.gioDismiss) oldFeedback.gioDismiss(false); else oldFeedback.remove(); }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      try { this.render(response, formData, aiSourceForm); }
      catch (error) {
        console.warn('Item added; cart confirmation used its fallback.', error);
        this.fallbackCartFeedback('Added to cart');
      }
    }

    /**
     * A dropped connection can hide a successful Shopify write. Before offering
     * a retry, read the cart and reconcile by the immutable AI CID so a retry
     * cannot create a duplicate paid-AI line.
     */
    reconcileAiCart(aiSubmission) {
      if (!aiSubmission || !aiSubmission.cid) {
        return Promise.resolve({ state: 'UNKNOWN', cart: null });
      }
      return this.readCart().then(function (cart) {
          var items = cart.items;
          for (var index = 0; index < items.length; index += 1) {
            var properties = items[index] && items[index].properties;
            if (
              properties &&
              String(properties._CustomizationId || '') === aiSubmission.cid
            ) return { state: 'FOUND', cart: cart };
          }
          return { state: 'ABSENT', cart: cart };
      }).catch(function () {
        return { state: 'UNKNOWN', cart: null };
      });
    }

    /** 收集购物车抽屉需要刷新的 section；普通购物车页面不要求提供这些 ID。 */
    sections() {
      var result = { sections: '', sections_url: window.location.pathname };
      if (!this.cart || typeof this.cart.getSectionsToRender !== 'function') return result;
      var sections = this.cart.getSectionsToRender() || [];
      var ids = [];
      for (var index = 0; index < sections.length; index += 1) {
        if (sections[index] && sections[index].id) ids.push(sections[index].id);
      }
      result.sections = ids.join(',');
      return result;
    }

    /**
     * 主商品成功后再异步加入 VIP 服务。
     * VIP 失败不会把主商品判定为失败，而是保留主响应并向用户显示警告。
     */
    addVip(quantity, sectionOptions, mainResponse, vipSubmission) {
      if (!vipSubmission) return Promise.resolve(mainResponse);
      if (typeof window.boxAddToCart !== 'function') {
        this.vipWarning = 'Your item was added. VIP Service was not added. Review your cart before checkout.';
        return Promise.resolve(mainResponse);
      }
      return Promise.resolve().then(function () {
        return window.boxAddToCart(quantity, Object.assign({}, sectionOptions, {
          variantId: vipSubmission.item.id, pairKey: vipSubmission.item.properties._tempVip, timeout: 10000
        }));
      }).then(function (response) {
        if (!response || !response.sections) return mainResponse;
        // VIP is an add-on to the item the customer just designed. Keep that
        // main item's key/identity, but use sections from the most recent cart
        // write so the badge, View cart count and drawer include both items.
        var combined = Object.assign({}, mainResponse);
        combined.sections = Object.assign({}, mainResponse.sections || {});
        Object.keys(response.sections).forEach(function (sectionId) {
          var html = response.sections[sectionId];
          // Shopify can return null for a section while the cart write succeeds.
          // Preserve the known-good main response instead of erasing the UI.
          if (typeof html !== 'string' || !html.trim()) return;
          if (sectionId === 'cart-notification-product' && mainResponse.key) {
            var sectionDocument = new DOMParser().parseFromString(html, 'text/html');
            if (!sectionDocument.getElementById('cart-notification-product-' + mainResponse.key)) return;
          }
          combined.sections[sectionId] = html;
        });
        return combined;
      }).catch((error) => {
        console.error('VIP Service add-to-cart failed after the main item succeeded:', error);
        if (error && error.ambiguous === false) {
          this.vipWarning = 'Your item was added. VIP Service was not added. Review your cart before checkout.';
          return mainResponse;
        }
        return this.reconcileOrdinaryCart(vipSubmission).then((result) => {
          this.vipWarning = result.state === 'FOUND'
            ? 'Your item and VIP Service were added. View cart for your updated total.'
            : 'Your item was added. We could not confirm VIP Service. Please check your cart before checkout; do not add the item again.';
          return mainResponse;
        });
      });
    }

    refreshCartCounts(response) {
      if (this.cart && this.cart.tagName === 'CART-DRAWER' && response.sections && typeof response.sections['cart-drawer'] === 'string') {
        try { this.cart.renderContents(response, { open: false }); }
        catch (error) { console.warn('Item saved; optional drawer refresh unavailable.', error); }
      }
      ['cart-icon-bubble', 'cart-notification-button'].forEach(function (id) {
        try {
          var target = document.getElementById(id), html = response.sections && response.sections[id];
          if (!target || typeof html !== 'string') return;
          var source = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (source) target.innerHTML = source.innerHTML;
        } catch (_) { /* Optional counts never change an already confirmed write. */ }
      });
    }

    /**
     * Keep the continuation tied to the actual successful AI submission. A
     * global product lookup could reopen another item (or a hidden Quick Add).
     * The source form remains the authority when the cart action is clicked.
     */
    personalizeAnotherContext(formData, aiSourceForm) {
      var productForm = this;
      var cid = String(formData.get('properties[_CustomizationId]') || '');
      if (!cid || !aiSourceForm || this.closest('quick-add-modal')) return null;
      var context = {
        cid: cid,
        root: aiSourceForm,
        isValid: function () {
          var state = aiSourceForm._giftInOneAiState;
          return Boolean(
            productForm.isConnected && aiSourceForm.isConnected &&
            productForm.scope.contains(aiSourceForm) &&
            aiSourceForm.dataset.productFormId === productForm.form.id &&
            !aiSourceForm.closest('quick-add-modal') && isVisible(aiSourceForm) &&
            aiSourceForm.dataset.aiMode === 'ai' && aiSourceForm.dataset.aiState === 'added' &&
            aiSourceForm.dataset.aiCartState !== 'unknown' && state &&
            !state.cartUnknown && !state.cartSubmitting &&
            String(state.selectedDesignCid || '') === cid &&
            state.cartCustomizationCids && state.cartCustomizationCids[cid]
          );
        },
        canStart: function () {
          var state = aiSourceForm._giftInOneAiState;
          return Boolean(context.isValid() && state.sessionReady &&
            !state.sessionRestoring && !state.cartChecking &&
            !state.busy && !state.finalizingDraftCid);
        },
        watch: function (onInvalid) {
          if (typeof window.MutationObserver !== 'function') return null;
          // Theme sections can replace the whole source product without a cart
          // rerender. Retire the continuation as soon as that happens.
          var observer = new window.MutationObserver(function () {
            if (!context.isValid()) onInvalid();
          });
          observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['data-ai-state', 'data-ai-mode', 'data-ai-cart-state']
          });
          return function () { observer.disconnect(); };
        },
        resume: function (trigger) {
          if (!context.canStart()) return false;
          var detail = { trigger: trigger, cid: cid, accepted: false };
          aiSourceForm.dispatchEvent(new window.CustomEvent('giftinone:personalize-another', {
            detail: detail
          }));
          return detail.accepted === true;
        }
      };
      return context.isValid() ? context : null;
    }

    /** 快速购买弹窗关闭后再刷新购物车，避免弹窗动画与抽屉渲染互相干扰。 */
    render(response, formData, aiSourceForm) {
      var continuation = this.personalizeAnotherContext(formData, aiSourceForm);
      if (this.cart && typeof this.cart.setPersonalizeAnotherContext === 'function') {
        // Every successful submission replaces the previous context, including
        // ordinary photo products, Quick Add and optional VIP responses.
        this.cart.setPersonalizeAnotherContext(null);
      }
      if (typeof PUB_SUB_EVENTS !== 'undefined') {
        safePublish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        });
      }
      if (!this.cart) {
        this.fallbackCartFeedback('Added to cart');
        return;
      }
      if (this.cart.classList && this.cart.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }
      var quickAdd = this.closest('quick-add-modal');
      if (quickAdd) {
        var cart = this.cart;
        document.body.addEventListener('modalClosed', function () {
          window.setTimeout(function () {
            try { if (cart && typeof cart.renderContents === 'function') cart.renderContents(response); }
            catch (error) { this.fallbackCartFeedback('Added to cart'); }
          }.bind(this), 0);
        }.bind(this), { once: true });
        quickAdd.hide(true);
      } else if (typeof this.cart.renderContents === 'function') {
        this.cart.renderContents(response);
        // Drawer rendering replaces its inner DOM, so set the action afterward.
        if (typeof this.cart.setPersonalizeAnotherContext === 'function') {
          this.cart.setPersonalizeAnotherContext(continuation);
        }
      } else this.fallbackCartFeedback('Added to cart');
    }

    /**
     * 加入购物车的底层方法：校验 → 展开定制属性 → 提交主商品 → 可选 VIP → 刷新购物车。
     * 所有步骤使用 Promise 串行执行，避免同步 Ajax 在 Firefox 中阻塞或失效。
     */
    submit() {
      var appendForm = findAppendForm(this);
      var aiReady = Boolean(
        appendForm && appendForm.matches &&
        appendForm.matches('form[data-gio-ai-form][data-ai-mode="ai"][data-ai-state="ready"]')
      );
      var quantity = this.quantity(appendForm);
      var validationError = this.validate(appendForm, quantity, aiReady);
      if (validationError) {
        this.showError(validationError);
        this.setSubmitting(false);
        return Promise.resolve(false);
      }

      // VIP：已勾选时先生成其临时表单数据，但真正加购必须等主商品成功后再执行。
      if (!aiReady && this.vipEnabled() && typeof window.cateTempVipHtml === 'function') {
        window.cateTempVipHtml();
      }
      this.showError('');

      // 合并商品表单与附加定制表单，再把图片映射和普通文字统一构造成行项目属性。
      var cubeRoot = this.scope.querySelector('[data-gio-cube6]');
      var dataForm = (cubeRoot && cubeRoot.closest('form[data-product-form]')) ||
        this.scope.querySelector('[data-product-form]') || this.form;
      // AI 行只接收完整 Preview、_CustomizationId、_DesignVersion、
      // _PreviewSchema、私有生产图链接 _HD 和签名的 _AIResetReceipt；不提交二次叠加图层。
      // _OriginalPhoto 始终禁用，避免把短期恢复 URL 写进订单。也不读取旧
      // File、OriginalPhoto 映射、HD、文字、VIP 或旧定制表单里的任何字段。
      var values = aiReady
        ? formValues(appendForm)
        : formValues(dataForm).concat(formValues(appendForm));
      // 商品支持 AI 不代表这次购买使用 AI。过滤旧控件残留的收据，
      // 确保普通照片订单（包括从 AI 切回普通上传）不会保存 _AIResetReceipt。
      if (!aiReady) values = values.filter(function (item) {
        return item.name !== 'properties[_AIResetReceipt]';
      });
      var properties;
      try {
        var manualCart = window.GIOMultiSurfaceEmergency && window.GIOMultiSurfaceEmergency.validateForCart(this.variantIdInput && this.variantIdInput.value, this.scope);
        properties = manualCart && manualCart.valid
          ? window.GIOMultiSurfaceEmergency.propertiesForCart(values)
          : buildProperties(values, appendForm);
      } catch (error) {
        this.showError(error.message);
        this.setSubmitting(false);
        return Promise.resolve(false);
      }

      // 从最终将写入 FormData 的属性中复制不可变快照。购物车响应期间即使
      // 页面 DOM 被重绘，这个 CID 仍然精确对应本次已提交的设计。
      var aiSubmission = aiReady ? {
        cid: String(properties['properties[_CustomizationId]'] || ''),
        previewUrl: String(properties['properties[Preview]'] || ''),
        originalUrl: String(properties['properties[_OriginalPhoto]'] || '')
      } : null;

      // 上传文件现在直接写入 orders 目录，不再依赖前端触发的 S3 对象复制流程。
      // 仅提交当前商品必要字段；图片 URL 已被展开成 Shopify properties[...]。
      // 创建一个新的 FormData 对象并遍历当前值，避免把重复或无关的表单字段提交给 Shopify。
      var formData = new FormData();
      formValues(this.form).forEach(function (item) {
        // 保留变体等必要键值；quantity 和 properties 在下方使用校验后的最终值重新写入。
        if (item.name !== 'quantity' && item.name.indexOf('properties[') !== 0) {
          formData.append(item.name, item.value);
        }
      });
      // 修改 quantity 的值：使用定制弹窗或当前商品区块中读取并校验后的数量。
      formData.append('quantity', quantity);
      Object.keys(properties).forEach(function (key) {
        if (key.indexOf('properties[') === 0) formData.append(key, properties[key]);
      });

      // 附带购物车抽屉所需的 section ID，使 Shopify 响应可直接刷新当前购物车界面。
      var sectionOptions = this.sections();
      if (sectionOptions.sections) formData.append('sections', sectionOptions.sections);
      formData.append('sections_url', sectionOptions.sections_url);
      if (this.cart && typeof this.cart.setActiveElement === 'function') {
        this.cart.setActiveElement(this.previouslyFocusedElement || document.activeElement);
      }

      var url = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';
      this.vipWarning = '';
      var ordinary = aiSubmission ? null : this.ordinarySubmission(formData);
      var vipBox = !aiReady && this.vipEnabled() && (this.scope.querySelector('#vipBox') || document.getElementById('vipBox'));
      var vipItem = vipBox && { id: String(vipBox.value), properties: { _tempVip: String(formData.get('properties[_tempVip]') || '') } };
      var vipSubmission = vipItem ? { item: vipItem, identity: cartIdentity(vipItem), quantity: Number(quantity), before: null } : null;
      var mainConfirmed = false, savedResponse = null;
      var completeSuccess = (mainResponse) => {
        mainConfirmed = true; savedResponse = mainResponse; this.error = false;
        if (ordinary) delete pendingCartSubmissions[ordinary.identity];
        if (aiSubmission) notifyAi(appendForm, 'giftinone:ai-cart-added', aiSubmission);
        // Confirm the main item immediately. Optional VIP work must not hide it.
        this.showCartSuccess(mainResponse, formData, aiSubmission ? appendForm : null);
        this.showCartStatus(vipSubmission ? 'Your item was added. Adding your selected VIP Service…' : '');
        return this.addVip(vipSubmission ? vipSubmission.quantity : quantity, sectionOptions, mainResponse, vipSubmission).then((latestResponse) => {
          this.refreshCartCounts(latestResponse);
          this.showCartStatus(this.vipWarning || (vipSubmission ? 'Your item and VIP Service were added.' : ''));
          if (this.vipWarning) this.handleErrorMessage(this.vipWarning);
          return latestResponse;
        });
      };
      if (ordinary && pendingCartSubmissions[ordinary.identity]) {
        // Repeated clicks after an interrupted request only reconcile that
        // exact design/quantity. They never issue another cart write.
        ordinary = pendingCartSubmissions[ordinary.identity];
        vipSubmission = ordinary.vipSubmission;
        return this.reconcileOrdinaryCart(ordinary).then((result) => {
          if (result.state === 'FOUND') return completeSuccess(result.item);
          this.fallbackCartFeedback('We could not confirm this item. Please check your cart before adding it again.');
          return false;
        }).finally(() => this.setSubmitting(false));
      }
      var baseline = ordinary || vipSubmission ? this.readCart(1500).then(function (cart) {
        if (ordinary) ordinary.before = matchingQuantity(cart, ordinary.identity);
        if (vipSubmission) vipSubmission.before = matchingQuantity(cart, vipSubmission.identity);
      }).catch(function () { /* A missing baseline does not block the first purchase. */ }) : Promise.resolve();
      if (aiSubmission) notifyAi(appendForm, 'giftinone:ai-cart-submit', aiSubmission);
      // 商品加入购物车的接口请求：主商品必须先成功，之后才允许提交依赖它的 VIP 服务。
      return baseline.then(() => this.requestJson(url, this.requestConfig(formData), 20000))
        .then((mainResponse) => {
          if (!mainResponse || !mainResponse.key || !mainResponse.id) {
            var error = new Error('The cart response was incomplete. Please check your cart.'); error.ambiguous = true; throw error;
          }
          return completeSuccess(mainResponse);
        }).catch((error) => {
          if (mainConfirmed) {
            console.warn('Item added; an optional confirmation step failed.', error);
            this.fallbackCartFeedback('Your item was added. Please check your cart for the latest details.');
            return savedResponse;
          }
          var finishFailure = () => {
            // 任一步失败都发布错误、恢复按钮与加载状态，使客户可以修正后再次提交。
            console.error('Add-to-cart failed:', error);
            this.error = true;
            var data = error && error.data ? error.data : {};
            if (aiSubmission) {
              notifyAi(appendForm, 'giftinone:ai-cart-error', {
                cid: aiSubmission.cid,
                previewUrl: aiSubmission.previewUrl,
                originalUrl: aiSubmission.originalUrl,
                message: error && error.message ? error.message : ''
              });
            }
            if (typeof PUB_SUB_EVENTS !== 'undefined') {
              safePublish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: data.errors || data.description || error.message,
                message: data.message || error.message,
              });
            }
            this.handleErrorMessage(error && error.message
              ? error.message
              : 'Could not add this item to cart. Please try again.');
            this.setSubmitting(false);
            return false;
          };

          var ambiguous = Boolean(
            error &&
            (error.ambiguous === true ||
              (error.ambiguous !== false && !error.data && /^(TypeError|AbortError)$/.test(error.name)))
          );
          if (!ambiguous) return finishFailure();
          if (ordinary) {
            ordinary.vipSubmission = vipSubmission;
            pendingCartSubmissions[ordinary.identity] = ordinary;
            return this.reconcileOrdinaryCart(ordinary).then((result) => {
              if (result.state === 'FOUND') return completeSuccess(result.item);
              this.error = true;
              this.handleErrorMessage('We could not confirm whether this design was added. Check your cart before adding it again.');
              this.fallbackCartFeedback('Please check your cart. This design has not been submitted again.');
              return false;
            });
          }
          return this.reconcileAiCart(aiSubmission).then((reconciliation) => {
            if (reconciliation.state === 'ABSENT') return finishFailure();
            if (reconciliation.state !== 'FOUND') {
              this.error = true;
              notifyAi(appendForm, 'giftinone:ai-cart-unknown', {
                cid: aiSubmission.cid,
                previewUrl: aiSubmission.previewUrl,
                originalUrl: aiSubmission.originalUrl,
                message: 'The cart could not be checked after an interrupted request.'
              });
              this.handleErrorMessage(
                'We could not confirm whether this item was added. Open or refresh your cart before trying again.'
              );
              this.setSubmitting(false);
              return false;
            }
            var cartData = reconciliation.cart;
            this.error = false;
            notifyAi(appendForm, 'giftinone:ai-cart-added', {
              cid: aiSubmission.cid,
              previewUrl: aiSubmission.previewUrl,
              originalUrl: aiSubmission.originalUrl,
              reconciled: true
            });
            this.setSubmitting(false);
            // The reconciliation response has no section HTML. Navigate to the
            // cart so the customer sees the authoritative line instead of a stale drawer.
            var destination = window.routes && window.routes.cart_url
              ? window.routes.cart_url
              : '/cart';
            window.setTimeout(function () {
              if (window.location && typeof window.location.assign === 'function') {
                window.location.assign(destination);
              }
            }, 0);
            return cartData;
          });
        }).finally(() => this.setSubmitting(false));
    }

    /**
     * 加入购物车的事件：接管浏览器原生提交、阻止页面跳转、拦截重复请求，并确认当前变体仍可售。
     * Number Style 等选项可能异步刷新变体，因此必须先按真实勾选项同步 variant ID。
     */
    onSubmitHandler(event) {
      event.preventDefault();
      // isSubmitting 在请求结束前保持为 true，拦截双击和弹窗重复触发的提交。
      if (this.isSubmitting || !this.form || !this.submitButton) return;

      // Custom Now 弹窗内切换 Number Style 后，外部 Shopify 变体刷新可能还在请求中。
      // 提交前先按当前真实勾选项同步 variant id；当前实现会在开启 loading 前拦截不可用变体，避免页面一直转圈。
      if (window.GiftinoneVariantSync &&
        typeof window.GiftinoneVariantSync.ensureCurrentVariantFromSelections === 'function') {
        window.GiftinoneVariantSync.ensureCurrentVariantFromSelections({ forceEnableSubmit: true });
      }
      if (this.variantDisabled || !this.variantIdInput || !this.variantIdInput.value) return;
      this.previouslyFocusedElement = document.activeElement;
      this.setSubmitting(true);
      Promise.resolve().then(() => this.submit()).catch((error) => {
        console.error('Cart action could not finish.', error);
        this.handleErrorMessage('The cart action could not finish. Please check your cart before trying again.');
      }).finally(() => this.setSubmitting(false));
    }

    /**
     * 更新 Shopify 标准商品错误区域；hide-errors 开启或当前区块没有错误容器时不渲染。
     * 有错误时移除 hidden 并写入纯文本，无错误时重新隐藏容器。
     */
    handleErrorMessage(message) {
      var cubeError = this.scope.querySelector('[data-gio-cube6] [data-cube-error]');
      if (cubeError) {
        cubeError.textContent = message || '';
        cubeError.hidden = !message;
      }
      if (this.hideErrors) return;
      this.errorWrapper = this.errorWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorWrapper) return;
      this.errorOutput = this.errorOutput || this.errorWrapper.querySelector('.product-form__error-message');
      if (message) {
        this.errorWrapper.removeAttribute('hidden');
        if (this.errorOutput) this.errorOutput.textContent = message;
      } else {
        this.errorWrapper.setAttribute('hidden', '');
      }
    }

    /**
     * 将可见的 Custom Now 和弹窗 Add to Cart 按钮同步为 Shopify 原生提交按钮的库存状态。
     * 变体请求期间只锁定按钮；收到带文案的最终禁用状态后才显示 Sold Out。
     * 同步当前商品定制弹窗中的 Add to Cart，售罄时改为 Sold Out 并使用真正的 disabled 状态。
     */
    syncCustomizeButtonState(disable, text) {
      var productInfo = this.closest('product-info');
      if (!productInfo) return;
      var effectiveDisabled = this.isSubmitting || Boolean(disable);
      var soldOut = Boolean(disable && text);
      var nativeCube = productInfo.querySelector('[data-gio-cube6]');
      if (nativeCube) {
        forEach(nativeCube.querySelectorAll('[data-cube-add]'), function (button) {
          if (!button.dataset.availableLabel) button.dataset.availableLabel = button.textContent || 'Add to cart';
          button.disabled = effectiveDisabled || nativeCube.dataset.cubeState !== 'ready';
          button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
          button.textContent = soldOut ? (text || 'Sold Out') : button.dataset.availableLabel;
        });
        return;
      }
      var buttons = productInfo.querySelectorAll(
        '#customButton.product-info_atc_btn, #inputImage.product-info_atc_btn'
      );
      forEach(buttons, function (button) {
        var label = button.querySelector('#customText');
        var loading = button.querySelector('#loadingBounce');
        button.setAttribute('aria-disabled', effectiveDisabled ? 'true' : 'false');
        button.classList.toggle('is-sold-out', soldOut);
        if (soldOut) {
          if (label) {
            label.textContent = button.dataset.soldOutLabel || 'Sold Out';
            label.style.display = '';
          }
          if (loading) loading.style.display = 'none';
        } else if (!effectiveDisabled && label) {
          label.textContent = button.dataset.availableLabel || 'Custom Now';
        }
      });

      var sectionId = this.dataset.sectionId || '';
      forEach(document.querySelectorAll('#nextButton.next-btns'), function (button) {
        if (sectionId && sectionId !== (button.dataset.sectionId || '')) return;
        button.disabled = effectiveDisabled;
        button.setAttribute('aria-disabled', effectiveDisabled ? 'true' : 'false');
        button.classList.toggle('is-sold-out', soldOut);
        if (soldOut) button.textContent = button.dataset.soldOutLabel || 'Sold Out';
        else if (!effectiveDisabled) button.textContent = button.dataset.availableLabel || 'Add to Cart';
      });
    }

    /** 更新 Shopify 原生加入购物车按钮，并让可见的定制按钮使用相同状态。 */
    toggleSubmitButton(disable, text) {
      if (disable === undefined) disable = true;
      this.variantDisabled = Boolean(disable);
      this.variantText = text || '';
      if (!this.submitButton) return;
      var effectiveDisabled = this.isSubmitting || this.variantDisabled;
      this.submitButton.disabled = effectiveDisabled;
      this.submitButton.setAttribute('aria-disabled', effectiveDisabled ? 'true' : 'false');
      if (this.submitButtonText) {
        if (this.variantDisabled && text) this.submitButtonText.textContent = text;
        else if (!this.variantDisabled && window.variantStrings) {
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
      this.syncCustomizeButtonState(this.variantDisabled, this.variantText);
    }
  }

  window.customElements.define('product-form', ProductForm);

  /**
   * pet Cart 表单验证：兼容旧裁剪器调用，校验每个图片上传位是否已有预览图。
   * 缺图的上传位会显示红色边框，并用返回值告知主加购流程是否可以继续。
   */
  window.cartValidate = function (type) {
    var emergency = window.GIOMultiSurfaceEmergency;
    var manualCheck = emergency && emergency.validateForCart();
    if (manualCheck) return !!manualCheck.valid;
    if (window.GIOEditorV2Config && (window.GIOEditorV2Config.templateEnabled == null ? window.GIOEditorV2Config.templateProfileKey : window.GIOEditorV2Config.templateEnabled)) {
      var bridge = window.GIOEditorV2TemplateAdapter;
      return !!(bridge && bridge.validateForCart().valid);
    }
    var invalid = 0;
    if (type === 'cropblanket' && window.jQuery) {
      window.jQuery('.uploadfont').each(function () {
        var item = window.jQuery(this);
        var hasImage = item.find('img').length > 0;
        item.find('.left').css('border', hasImage ? '1px solid #ccc' : '1px solid #f00000');
        if (!hasImage) invalid += 1;
      });
    }
    return invalid === 0;
  };

  /**
   * text Cart 表单验证：兼容旧裁剪器调用，校验所有必填定制文字。
   * 空白输入框显示红色边框，全部填写后恢复默认边框。
   */
  window.textValidate = function () {
    var emergency = window.GIOMultiSurfaceEmergency;
    var manualCheck = emergency && emergency.validateForCart();
    if (manualCheck) return !!manualCheck.valid;
    if (window.GIOEditorV2Config && (window.GIOEditorV2Config.templateEnabled == null ? window.GIOEditorV2Config.templateProfileKey : window.GIOEditorV2Config.templateEnabled)) {
      var bridge = window.GIOEditorV2TemplateAdapter;
      return !!(bridge && bridge.validateText().valid);
    }
    var valid = true;
    if (!window.jQuery) return valid;
    window.jQuery('.text-item-wrap input[type="text"]').each(function () {
      var input = window.jQuery(this);
      var filled = Boolean(String(input.val() || '').trim());
      input.css('border', filled ? '1px solid #ccc' : '1px solid #f00000');
      if (!filled) valid = false;
    });
    return valid;
  };
})(window, document);
